$(document).on('change','variant-radios-list input',function(e){
    var variants = {};
    variants["productId"] = $(this)
        .parents("variant-radios-list")
        .attr("data-product-id");
    variants["sectionId"] = $(this)
    .parents("variant-radios-list")
    .attr("data-section");
    variants["productVariants"] = JSON.parse(
        $("#product-" + variants.productId).html()
    );

    var radioButtonSelection = variants.sectionId+'-'+variants.productId;
    var selectedRadios = $(
        "variant-radios-list input[id*=" + radioButtonSelection + "]:checked"
    );
    variants["combination"] = selectedRadios
        .map(function () {
            return this.value;
        })
        .get()
        .join(" / ");
    variants["variantImages"] = {};

    $.each(variants.productVariants, function (key, val) {
        variants.variantImages[val.title] = {
            imageUrl: val.featured_image.src,
            id: val.id,
            price:val.price,
        };
    });

    var productImgEl = $(
        "div[data-product-id*=" + radioButtonSelection + "] img"
    ).first();
    var currentImgSrc = productImgEl.attr("src").split("&width=")[0];
    var newImgSrc = variants.variantImages[variants.combination].imageUrl;

    productImgEl.attr("srcset", function (key, val) {
        return val.replaceAll(currentImgSrc, newImgSrc);
    });

    productImgEl.attr("src", newImgSrc);

    var productVariantToCartFormEl = $(
        "div[data-product-id*=" +
            variants.productId +
            "] product-form input[name=id]"
    );
    productVariantToCartFormEl.attr(
        "value",
        variants.variantImages[variants.combination].id
    );

    var productPrice = $(
        "div[data-product-id*=" + radioButtonSelection + "] span.price"
    ).first();    
    var newPrice = variants.variantImages[variants.combination].price;
    productPrice.html(Shopify.formatMoney(newPrice));

    e.stopPropagation();
});